//Defining what Ziplyne is to the viewer

import React, { useEffect } from "react";

import WhatIsZiplyneImage from "../../assets/WhatIsZiplyne.png";
import Confetti1 from "../../assets/confetti1.png";
import Confetti2 from "../../assets/confetti2.png";

import AOS from "aos";
import "aos/dist/aos.css";

const WhatIsZiplyne = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 2500,
    });
  }, []);

  return (
    <div id="WhatIsZiplyne">
      <h2 data-aos={"fade-left"} className="WhatIsZiplyne__title"> 
        What is a Digital Adoption Platform and Ziplyne?
      </h2>
      <p data-aos={"fade-left"} className="WhatIsZiplyne__description">
        A Digital Adoption Platform (DAP) is an Enterprise Solution designed to
        ease pain points and augment software experiences related to onboarding,
        training, support and adoption. <br />
        <br />
        Incubated at the Johns Hopkins Social Innovation Lab, Ziplyne is an
        emerging Digital Adoption Platform with multiple Johns Hopkins alumni on
        its current leadership team. Think of Ziplyne as your interactive step-by-step guide on the side.
      </p>
      <img
        data-aos={"fade-right"}
        className="WhatIsZiplyne--background"
        src={WhatIsZiplyneImage}
        alt=""
      />
      <img className="WhatIsZiplyne__confetti--1" src={Confetti1} alt="" />
      <img className="WhatIsZiplyne__confetti--2" src={Confetti2} alt="" />
    </div>
  );
};

export default WhatIsZiplyne;
